<h2>
    {{categoryName| async}}
    <button mat-icon-button aria-label="Add petition" (click)="onAddPetition()">
        <mat-icon>add</mat-icon>
    </button>
</h2>

<app-loading-overlay [isLoading$]="isLoading$"></app-loading-overlay>

<app-petition-state-list [title]="'Active Petitions'" [petitions]="activePetitions$ | async"
    (editClick)="onEditPetition($event)" (deleteClick)="onDeletePetition($event)">
</app-petition-state-list>

<app-petition-state-list [title]="'Pending Petitions'" [petitions]="pendingPetitions$ | async"
    (editClick)="onEditPetition($event)" (deleteClick)="onDeletePetition($event)">
</app-petition-state-list>

<app-petition-state-list [title]="'Lapsed Petitions'" [petitions]="lapsedPetitions$ | async"
    (editClick)="onEditPetition($event)" (deleteClick)="onDeletePetition($event)">
</app-petition-state-list>
